module.exports = __webpack_public_path__ + "assets/img/ko-7e383475.png";